import Component from '@glimmer/component';
import config from 'frontend/config/environment';

export interface ActionProductSearchResult {
  id: string;
  startAt: string;
  endAt: string;
  slug: string;
  tags: string[];
  type: string;
  resourceType: string;
  modality: string;
  targetAudience: string;
  coverImage?: string;
  families: string[];
  productId: string;
  name: string;
  introduction: {
    short: string;
    full: string;
  };
}

interface SearchPageCardComponentArgs {
  onlyProduct?: boolean;
  formation: ActionProductSearchResult;
}

export default class SearchPageCardComponent extends Component<SearchPageCardComponentArgs> {
  get imageUrl() {
    return this.args.formation.coverImage
      ? `${config.static}covers/${this.args.formation.coverImage}`
      : `/assets/images/${this.args.formation.targetAudience}-placeholder.png`;
  }

  get routeToRedirect() {
    if (this.args.onlyProduct) {
      return 'catalog.product';
    }
    return this.args.formation.resourceType === 'product'
      ? 'catalog.product'
      : 'catalog.action';
  }

  get sizeFamiliesForIndexComparison() {
    return this.args.formation.families.length - 1;
  }
}
